<div class="relative">
    <span
        class="border-4"
        style="box-shadow: black 0 0 0 0.0625rem"
        [class.border-dashed]="!isContinue()"
        [class.border-solid]="isContinue()"
        [class.text-white]="!fiberNumber()"
        [id]="anchorId()"
        [style.border-color]="fiberColor()"
        >{{ (fiberNumber() | number: '2.0') ?? '00' }}</span
    >
    @if (!fiberNumber()) {
        <button
            class="plusButton"
            [class.left-8]="side() === CableDirectionEnum.RIGHT"
            [class.plusButton_assigned]="!isSelectionEnabled()"
            [class.plusButton_free]="isSelectionEnabled()"
            [class.plusButton_selected]="isCassettePositionSelected()"
            [class.plusButton_unselected]="!isCassettePositionSelected()"
            [class.right-8]="side() === CableDirectionEnum.LEFT"
            [disabled]="!isSelectionEnabled()"
            (click)="$event.stopPropagation(); selectCassettePosition(side(), positionId())">
            <fa-icon
                size="xs"
                [class]="isSelectionEnabled() ? 'text-custom-blue' : 'text-custom-dark-grey'"
                [icon]="['fas', 'plus']" />
        </button>
    }
</div>
